import { useConsole } from "contexts/Console"
import styled from "@emotion/styled"
import getMediaQuery from "css/breakpoints"

const Root = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  z-index: 2;
  pointer-events: none;
  inset: auto 0 10px 0;

  opacity: var(--mo, 0);
  transition: opacity 300ms;

  ${getMediaQuery("m")} {
    inset: auto 0 30px 0;
  }
  html.prefers-contrast & {
    background: rgb(var(--pure-white));
  }

  & > svg {
    width: 42px;
    height: 100%;

    ${getMediaQuery("m")} {
      width: 52px;
    }
  }

  & > svg path {
    fill: rgb(var(--theme));
    stroke: transparent;

    &.alt {
      stroke: rgb(var(--theme));
      fill: transparent;
    }
  }
`

export default function Icon({ variation, theme }) {
  const console = useConsole()

  console.verbose("FamilyVariations:Icon(%s) {%o}", variation?.rmc, { variation })
  return (
    <Root style={{ "--mo": +variation.ballerina, "--theme": theme?.theme === "dark-theme" ? "255 255 255" : "33 33 33" }}>
      <svg viewBox='0 0 15 8.07481' aria-hidden='true'>
        <path d='m7,6.0748c-1.1,0-2-.2-2.9-.3-1.1-.2-2-.5-2.5-.8-.6-.3-1-.8-1-1.2,0-.2.1-.4.2-.6-.5.2-.8.7-.8,1.1,0,1.4,3.1,2.6,7,2.7v1.1l2-1.6-2-1.6v1.2h0Zm7.3-3c.1.2.2.4.2.6,0,.5-.3.9-1,1.3-.9.6-2.5,1-4.5,1.1v1c3.4-.3,6-1.4,6-2.8,0-.4-.2-.8-.7-1.2ZM4.18604.74023c-.07812.10352-.11572.24316-.1123.41699h-.64941c.00635-.17578.03662-.34277.09033-.50098.05713-.1377.14648-.26562.26855-.38281.09131-.08301.19922-.14648.32471-.19043s.2793-.06543.46143-.06543c.33838,0,.61182.08691.81885.26172.20801.1748.31152.41016.31152.70508,0,.20801-.06201.38379-.18555.52734-.07812.08887-.15967.15039-.24414.18262.06348,0,.15479.05469.27344.16309.17725.16504.26611.38965.26611.67383,0,.2998-.104.56348-.31104.79004-.20801.22754-.51514.34082-.92188.34082-.50146,0-.84961-.16406-1.04492-.49023-.10254-.1748-.15967-.40234-.1709-.68359h.68359c0,.14062.02295.25781.06836.35156.08447.16992.23828.25586.46143.25586.13672,0,.25586-.04688.35791-.14062.10156-.09375.15234-.22852.15234-.4043,0-.23242-.09424-.3877-.2832-.46582-.10742-.04395-.27686-.06543-.50781-.06543v-.49805c.22607-.00391.38428-.02539.47363-.06641.15479-.06836.23193-.20703.23193-.41504,0-.13477-.03955-.24512-.11865-.3291-.07861-.08496-.18994-.12695-.33301-.12695-.16455,0-.28467.05176-.36133.15625Zm3.35205.53711c.31396,0,.57227.10645.77246.31934.20117.21289.30176.48535.30176.81738,0,.33105-.09863.62207-.29492.875-.19727.25195-.50342.37793-.91846.37793-.4458,0-.7749-.18652-.98633-.55957-.16455-.29102-.24658-.66699-.24658-1.12695,0-.27051.01123-.49023.03418-.66016.04053-.30078.11963-.55078.23682-.75195.10107-.16992.23291-.30762.39697-.41211.16309-.10449.35889-.15625.58691-.15625.32861,0,.59082.08398.78613.25293.19531.16797.30566.39258.33008.67285h-.69385c0-.05762-.02197-.12012-.06592-.18848-.07471-.11035-.18799-.16602-.33936-.16602-.22607,0-.38721.12695-.4834.38086-.05225.13965-.08789.34668-.10742.62012.08643-.10254.18652-.17773.30029-.22461s.24414-.07031.39062-.07031Zm-.46875.66406c-.13672.10547-.20508.27637-.20508.51172,0,.19141.05127.34668.15381.4668s.23291.18066.39062.18066c.15479,0,.27637-.05859.36475-.1748.08887-.11621.1333-.26758.1333-.45312,0-.20605-.05029-.36426-.15137-.47461-.10107-.10938-.22461-.16406-.37109-.16406-.11865,0-.22363.03516-.31494.10742Zm3.09863,1.7207c-.45117,0-.76758-.1582-.94824-.47363-.18164-.31543-.27246-.76562-.27246-1.35059,0-.58398.09082-1.03516.27246-1.35156.18066-.31836.49707-.47656.94824-.47656.4502,0,.76758.1582.94922.47656.18066.31641.27148.76758.27148,1.35156,0,.58496-.09082,1.03516-.27246,1.35059s-.49805.47363-.94824.47363Zm.40723-.89062c.06348-.21484.0957-.52637.0957-.93359,0-.42578-.03223-.74219-.09668-.94727s-.2002-.30664-.40625-.30664c-.20703,0-.34375.10156-.41016.30664-.06738.20508-.10059.52148-.10059.94727,0,.40723.0332.71875.10059.93457.06641.21582.20312.32324.41016.32324.20605,0,.34277-.1084.40723-.32422ZM13.14648.24219c.1543.15625.23145.3418.23145.55664s-.07715.39941-.2334.55469c-.15527.15527-.33984.2334-.55469.2334s-.40039-.07812-.55566-.2334-.2334-.33984-.2334-.55469.07812-.40039.2334-.55566.34082-.2334.55566-.2334.40039.07715.55664.23242Zm-.27832.83398c.07617-.07617.11426-.16895.11426-.27734,0-.10938-.03809-.20215-.11426-.2793-.07715-.07617-.16992-.11426-.27832-.11426-.10938,0-.20215.03809-.27832.11426-.07715.07715-.11523.16992-.11523.2793,0,.1084.03809.20117.11523.27734.07617.07715.16895.11523.27832.11523.1084,0,.20117-.03809.27832-.11523Z' />
      </svg>
    </Root>
  )
}
